// action type strings
import * as actionTypes from '../../actionTypes';

export function createJobRequest(jobRequest) {
  return {
    type: actionTypes.CREATE_JOB_REQUEST,
    jobRequest
  };
}

export function updateJobRequest(jobRequest) {
  return {
    type: actionTypes.UPDATE_JOB_REQUEST,
    jobRequest
  };
}

export function resetJobRequest() {
  return {
    type: actionTypes.RESET_JOB_REQUEST,
  };
}

export function updateJobRequests(jobRequests) {
  return {
    type: actionTypes.UPDATE_JOB_REQUESTS,
    jobRequests
  };
}

export function updateCompanyJobRequests(companyJobRequests) {
  return {
    type: actionTypes.UPDATE_COMPANY_JOB_REQUESTS,
    companyJobRequests
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/jobrequests.js